import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import { customerRoutes } from "./routes/customerRoutes";
import { adminRoutes } from "./routes/adminRoutes";
import NotFoundPage from "./pages/NotFoundPage";
import RouteLoader from "./components/RouteLoader";

const AppRoutes = () => {
  return (
    <main id="main-content">
      <Suspense fallback={<RouteLoader />}>
        <Routes>
          {customerRoutes}
          {adminRoutes}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </main>
  );
};

export default AppRoutes;






